






















































































































































































































import StInput from '@/components/basic/StInput.vue';

import { notifyError, notifySuccess } from '@/utlitities/notifications';
import { Component, Vue, Watch } from 'vue-property-decorator';
import MainMenu from '@/components/main-menu/MainMenu.vue';
import { UserStore } from '@/store/user-module';
import { AppUserViewModel, MenuColorEnum, SupportRequestModel } from '@/services/api/nswag/stapiclient_generated';
import { stImpersonationApi, stAuthenticationApi, supportApi, stAppUserApi } from '@/services/st-api';
import { StopwatchStore } from '@/store/stopwatch-store';
import { AccountStore } from '@/store/account-module';
import { getHoursFromSeconds } from '@/utlitities/helper';
import OnBoarding from '@/views/OnBoarding/OnBoarding.vue';
import OnBoardingTour from '@/views/OnBoarding/OnBoardingTour.vue';
import OnBoardingMigration from '@/views/OnBoarding/OnBoardingMigration.vue';
import StProgress from '@/components/basic/StProgress.vue';
import StNotification from '@/components/basic/StNotification.vue';
import {TimeEntryStore} from '@/store/time-entry-store';
import MainMenuItem from "@/components/main-menu/MainMenuItem.vue";

@Component({
  components: {
    MainMenuItem,
    StNotification,
    StProgress,
    OnBoardingTour,
    OnBoarding,
    OnBoardingMigration,
    MainMenu,
    StInput,
  },
})
export default class DefaultLayout extends Vue {
  showFeedbackWindow = false;

  feedbackSending = false;
  supportRequestModel: SupportRequestModel = SupportRequestModel.fromJS({});
  showMenu = false;
  untouched = true;
  settingsOpen = false;

  appTitle: string = document.title;

  get accountPaymentIsSetup() {
    return UserStore.userSettings.paymentStatus.paymentIsSetup;
  }

  get dataLoaded() {
    return UserStore.dataLoaded;
  }

  goToTimeEntries() {
    this.$router.push({ name: 'TimeEntries' });
  }

  get stopwatchRunning() {
    return StopwatchStore.IsRunning;
  }

  get stopwatchModel() {
    return StopwatchStore.StopwatchModel;
  }

  get durationSeconds() {
    return StopwatchStore.IsRunning ? StopwatchStore.RunningSeconds : 0;
  }

  get userSettings() {
    return UserStore.userSettings;
  }

  get isMigratedFromSt2() {
    return this.userSettings.isMigratedFromSt2;
  }

  get showOnboarding() {
    return !this.userSettings.onboardingCompleted;
  }

  @Watch('stopwatchRunning')
  @Watch('durationSeconds')
  adjustTitle() {
    if (this.stopwatchRunning) {
      document.title = getHoursFromSeconds(this.durationSeconds) + ' - ' + this.appTitle;
    } else {
      document.title = this.appTitle;
    }
  }

  interval: any;

  async mounted() {
    this.$router.afterEach((to, from) => (this.showMenu = false));

    if (UserStore.isLoggedIn) {
      await this.$root.$stHub.start();
      await this.$root.$stHub.logon();
    }

    this.interval = setInterval(async () => {
      if (this.$root.$stHub.getIsDisconnected() && UserStore.isLoggedIn) {
        await this.$root.$stHub.start();
        await this.$root.$stHub.logon();
      }
    }, 10000);
  }

  async destroyed() {
    clearInterval(this.interval);
    await this.$root.$stHub.logoff();
    await this.$root.$stHub.stop();
  }

  get useProjectTimeTracking(){
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  get useAbsences() {
    return UserStore.userSettings.useAbsences;
  }

  get stopwatch() {
    return StopwatchStore.StopwatchModel;
  }

  get logoUrl() {
    return AccountStore.logo;
  }

  get menuClass() {
    return UserStore.userSettings.menuColor.toString().toLowerCase();
  }

  get lightMenu() {
    switch (UserStore.userSettings.menuColor) {
      case MenuColorEnum.Dark:
        return false;
      case MenuColorEnum.Light:
        return true;
      case MenuColorEnum.Primary:
        return !UserStore.primaryColorIsDark;
      case MenuColorEnum.Secondary:
        return !UserStore.secondaryColorIsDark;
    }
  }

  get appIsReady(): boolean {
    return AccountStore.isLoaded;
  }

  async impersonate(id: number) {
    await stImpersonationApi.impersonateUser(id);
    location.reload();
  }

  async logout() {
    await stAuthenticationApi.logout();
    UserStore.resetStore();
    TimeEntryStore.Reset(true);
    await this.$router.push({ name: 'Login' });
  }

  async stopImpersonation() {
    await stImpersonationApi.stopImpersonation();
    location.reload();
  }

  get userName() {
    return UserStore.userSettings.appUserName;
  }

  setShowFeedback(show: boolean) {
    if (show) {
      this.supportRequestModel.email = UserStore.currentUser.email;
    }
    this.showFeedbackWindow = show;
  }

  async submitFeedback() {
    this.feedbackSending = true;

    try {
      await supportApi.sendSupportRequest(this.supportRequestModel);
      this.setShowFeedback(false);
      notifySuccess('Danke! Ihre Nachricht wurde gesendet.');
      this.supportRequestModel.text = '';
    } catch (err) {
      notifyError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
    } finally {
      this.feedbackSending = false;
    }
  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
    this.untouched = false;
  }

  goToMigration() {
    this.$router.push({ name: 'Migration' });
  }

  goToUserSettings() {
    this.$router.push({ name: 'UserSettings' });
  }


  sendingEmail = false;
  displaySendEmail = true;

  async resendActivationMail() {
    this.sendingEmail = true;
    await stAppUserApi.resendAccountActivation();
    this.sendingEmail = false;
    this.displaySendEmail = false;
  }
}
